package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.Regex.OTIOT
import com.eladfinish.bible.contest.extensions.runIf

object RegexUtils {

    const val UNDERSCORES = "_+"

    //delete book and chapter from the content
    fun getOnlyContent(
        chapterContent: String,
        onlyQri: Boolean = true,
    ): String {
        var onlyContent = chapterContent
        StringConstants.Regex.FIRST_VERSE.toRegex().find(chapterContent)?.let {
            val contentBeginning = chapterContent.indexOf(it.groups[3]!!.value)
            onlyContent = onlyContent.substring(contentBeginning)
        }
        onlyContent = onlyContent
            .runIf(condition = onlyQri) {
                replaceKtivWithQriNew()
            }
            .removeWhitespacesAndParshiot()
            .trim()
        return onlyContent
    }

    fun getMatchResultOfParashaSource(input: String): MatchResult? =
        "$OTIOT,$OTIOT-(?:.*?-)?$OTIOT,$OTIOT".toRegex().find(input)

}
